import { AxiosResponse } from "axios";
import fileDownload from "js-file-download";
import { AppDispatch } from "store";
import { GetSelectList } from 'api/types';
import { NoteForm } from "store/reducers/activity-log/add-note/types";
import { AddEditRoomData, AddEditRoomParams, ADD_EDIT_ROOM_FAILURE, ADD_EDIT_ROOM_REQUEST, ADD_EDIT_ROOM_SUCCESS } from 'store/reducers/room/add-edit-room/types';
import { DeleteRoomData, DeleteRoomParams, DELETE_ROOM_FAILURE, DELETE_ROOM_REQUEST, DELETE_ROOM_SUCCESS } from "store/reducers/room/deleteRoom/types";
import { RoomExportExcelParams, ROOM_EXPORT_EXCEL_FAILURE, ROOM_EXPORT_EXCEL_REQUEST, ROOM_EXPORT_EXCEL_SUCCESS } from "store/reducers/room/exportExcel/types";
import { RoomFormData, ROOM_FORM_DATA_FAILURE, ROOM_FORM_DATA_REQUEST, ROOM_FORM_DATA_SUCCESS } from "store/reducers/room/formData/types";
import { GET_ROOM_ACTIVITY_LOGS_FAILURE, GET_ROOM_ACTIVITY_LOGS_REQUEST, GET_ROOM_ACTIVITY_LOGS_SUCCESS } from "store/reducers/room/get-activity-logs/types";
import { ROOM_DETAILS_FAILURE, ROOM_DETAILS_REQUEST, ROOM_DETAILS_SUCCESS } from "store/reducers/room/get-details/types";
import { LocationMatchesRoomsForMassBookingParams, LOCATION_MATCHES_ROOMS_FOR_MASS_BOOKING_FAILURE, LOCATION_MATCHES_ROOMS_FOR_MASS_BOOKING_REQUEST, LOCATION_MATCHES_ROOMS_FOR_MASS_BOOKING_SUCCESS } from "store/reducers/room/location-matches-rooms-for-mass-booking/types";
import { LocationMatchesRoomsData, LocationMatchesRoomsParams, LOCATION_MATCHES_ROOMS_FAILURE, LOCATION_MATCHES_ROOMS_REQUEST, LOCATION_MATCHES_ROOMS_SUCCESS } from "store/reducers/room/locationMatchesRooms/types";
import { LocationRoomsData, LocationRoomsParams, LOCATION_ROOMS_FAILURE, LOCATION_ROOMS_REQUEST, LOCATION_ROOMS_SUCCESS } from "store/reducers/room/locationRooms/types";
import { RoomMassAddData, RoomMassAddParams, ROOM_MASS_ADD_DATA_FAILURE, ROOM_MASS_ADD_DATA_REQUEST, ROOM_MASS_ADD_DATA_SUCCESS } from "store/reducers/room/massAdd/types";
import { ReactivateRoomData, REACTIVATE_ROOM_FAILURE, REACTIVATE_ROOM_REQUEST, REACTIVATE_ROOM_SUCCESS } from "store/reducers/room/reactivate/types";
import { READ_RESERVATIONS_DATA_FAILURE, READ_RESERVATIONS_DATA_REQUEST, READ_RESERVATIONS_DATA_SUCCESS, ReservationsData, ReservationsParams } from "store/reducers/room/readReservationsData/types";
import { READ_RESERVATIONS_FILTERS_FAILURE, READ_RESERVATIONS_FILTERS_REQUEST, READ_RESERVATIONS_FILTERS_SUCCESS, ReservationsFilterData } from "store/reducers/room/readReservationsFilters/types";
import { SET_RESERVATION_TABLE_FILTERS } from "store/reducers/room/reservationTableFilters/types";
import { BaseTableRequest, Filters } from "store/types";
import { apiRequest } from "utils/api";
import {
  READ_OCCUPANCY_RATE_DATA_REQUEST,
  READ_OCCUPANCY_RATE_DATA_SUCCESS,
  READ_OCCUPANCY_RATE_DATA_FAILURE, OccupancyRateData, OccupancyRateParams
} from "store/reducers/room/readOccupancyRateData/types";
import { SET_OCCUPANCY_RATE_TABLE_FILTERS } from "store/reducers/room/occupancyRateTableFilters/types";
import {
  OccupancyRateFilterData, READ_OCCUPANCY_RATE_FILTERS_FAILURE,
  READ_OCCUPANCY_RATE_FILTERS_REQUEST, READ_OCCUPANCY_RATE_FILTERS_SUCCESS
} from "store/reducers/room/readOccupancyRateFilters/types";
import {
  GET_RESERVATIONS_COUNT_DATA_FAILURE,
  GET_RESERVATIONS_COUNT_DATA_REQUEST,
  GET_RESERVATIONS_COUNT_DATA_SUCCESS
} from "store/reducers/room/get-count/types";
import {
  GET_ACTIVE_RESERVATIONS_COUNT_DATA_FAILURE,
  GET_ACTIVE_RESERVATIONS_COUNT_DATA_REQUEST,
  GET_ACTIVE_RESERVATIONS_COUNT_DATA_SUCCESS
} from "../reducers/room/get-active-reservations-count/types";
import {
  MOVE_ROOM_FAILURE,
  MOVE_ROOM_REQUEST,
  MOVE_ROOM_SUCCESS,
  MoveRoomData,
  MoveRoomParams
} from "store/reducers/room/moveRoom/types";
import { GetMassActionsParams, MASS_ACTIONS_FAILURE, MASS_ACTIONS_REQUEST, MASS_ACTIONS_SUCCESS } from "store/reducers/room/get-mass-actions/types";
import { MassAddNoteFormReservations as MassAddNoteForm } from "store/reducers/activity-log/mass-add-note/types";
import { massEditDateParams } from "store/reducers/room/mass-edit-dates/types";
import { massMoveRoomParams } from "store/reducers/room/mass-move-rooms/types";
import { massCancelRoomParams } from "store/reducers/room/mass-cancel-rooms/types";
import {
  ROOM_REPORT_EXCEL_FAILURE,
  ROOM_REPORT_EXCEL_REQUEST,
  ROOM_REPORT_EXCEL_SUCCESS,
  RoomReportExcelParams
} from "store/reducers/room/getReportExcel/types";

export function addEditRoom(params: AddEditRoomParams, id?: string): any {
  return async (dispatch: AppDispatch): Promise<AddEditRoomData> => {
    dispatch({ type: ADD_EDIT_ROOM_REQUEST });

    try {
      const response = !id ?
        await apiRequest("post", `room/add`, { data: params }) :
        await apiRequest("put", `room/edit`, { data: params });
      dispatch({
        type: ADD_EDIT_ROOM_SUCCESS,
        contents: response?.data || {}
      });

      return response?.data || {};
    } catch (response: any) {
      const error = response && response.error;

      dispatch({
        type: ADD_EDIT_ROOM_FAILURE,
        error
      });

      throw response;
    }
  };
};

export function moveRoom(params: MoveRoomParams): any {
  return async (dispatch: AppDispatch): Promise<MoveRoomData> => {
    dispatch({ type: MOVE_ROOM_REQUEST });

    try {
      const response = await apiRequest(
        "post",
        `room/move`,
        {
          data: params
        }
      );
      dispatch({
        type: MOVE_ROOM_SUCCESS,
        contents: response?.data || {}
      });

      return response?.data || {};
    } catch (response: any) {
      const error = response && response.error;

      dispatch({
        type: MOVE_ROOM_FAILURE,
        error
      });

      throw response;
    }
  };
};

export function deleteRoom(id: string, data: DeleteRoomParams): any {
  return async (dispatch: AppDispatch): Promise<DeleteRoomData> => {
    dispatch({ type: DELETE_ROOM_REQUEST });

    try {
      const response = await apiRequest(
        "put",
        `room/${id}/cancel`,
        { data }
      );
      dispatch({
        type: DELETE_ROOM_SUCCESS,
        contents: response?.data || {}
      });

      return response?.data || {};
    } catch (response: any) {
      const error = response && response.error;

      dispatch({
        type: DELETE_ROOM_FAILURE,
        error
      });

      throw response;
    }
  };
};

export function roomFormData(id?: string, lodgingOptionId?: string): any {
  return async (dispatch: AppDispatch): Promise<RoomFormData> => {
    dispatch({ type: ROOM_FORM_DATA_REQUEST });

    const queryString: string = id ? `?id=${id}` : lodgingOptionId ? `?lodgingOptionId=${lodgingOptionId}` : '';

    try {
      const response = await apiRequest(
        "get",
        `room/get-form-data${queryString}`
      );
      dispatch({
        type: ROOM_FORM_DATA_SUCCESS,
        contents: response?.data || {}
      });

      return response?.data || {};
    } catch (response: any) {
      const error = response && response.error;

      dispatch({
        type: ROOM_FORM_DATA_FAILURE,
        error
      });

      throw response;
    }
  };
};

export function locationMatchesRooms(params: LocationMatchesRoomsParams): any {
  return async (dispatch: AppDispatch): Promise<LocationMatchesRoomsData> => {
    dispatch({ type: LOCATION_MATCHES_ROOMS_REQUEST });

    try {
      const response = await apiRequest(
        "post",
        `room/location-matches-rooms`,
        {
          data: params
        }
      );

      dispatch({
        type: LOCATION_MATCHES_ROOMS_SUCCESS,
        contents: response?.data || {}
      });

      return response?.data || {};
    } catch (response: any) {
      const error = response && response.error;

      dispatch({
        type: LOCATION_MATCHES_ROOMS_FAILURE,
        error
      });

      throw response;
    }
  };
};

export function locationRooms(params: LocationRoomsParams): any {
  return async (dispatch: AppDispatch): Promise<LocationRoomsData> => {
    dispatch({ type: LOCATION_ROOMS_REQUEST });

    try {
      const response = await apiRequest(
        "post",
        `room/location-rooms`,
        {
          data: params
        }
      );

      dispatch({
        type: LOCATION_ROOMS_SUCCESS,
        contents: response?.data || {}
      });

      return response?.data || {};
    } catch (response: any) {
      const error = response && response.error;

      dispatch({
        type: LOCATION_ROOMS_FAILURE,
        error
      });

      throw response;
    }
  };
};

export function readReservationsData(params: ReservationsParams): any {
  return async (dispatch: AppDispatch): Promise<ReservationsData> => {
    dispatch({ type: READ_RESERVATIONS_DATA_REQUEST });

    try {
      const response = await apiRequest(
        "post",
        `room/reservations`,
        {
          data: params
        }
      );
      dispatch({
        type: READ_RESERVATIONS_DATA_SUCCESS,
        contents: response?.data || {}
      });

      return response?.data || {};
    } catch (response: any) {
      const error = response && response.error;

      dispatch({
        type: READ_RESERVATIONS_DATA_FAILURE,
        error
      });

      throw response;
    }
  };
};

export async function readReservationsWithoutStore(params: ReservationsParams): Promise<ReservationsData> {

  try {
    const response = await apiRequest(
      "post",
      `room/reservations`,
      {
        data: params
      }
    );
    return response?.data || {};
  } catch (response: any) {
    throw response;
  }
};


export function readOccupancyRateData(params: OccupancyRateParams): any {
  return async (dispatch: AppDispatch): Promise<OccupancyRateData> => {
    dispatch({ type: READ_OCCUPANCY_RATE_DATA_REQUEST });

    try {
      const response = await apiRequest(
        "post",
        `room/occupancy-rate`,
        {
          data: params
        }
      );
      dispatch({
        type: READ_OCCUPANCY_RATE_DATA_SUCCESS,
        contents: response?.data || {}
      });

      return response?.data || {};
    } catch (response: any) {
      const error = response && response.error;

      dispatch({
        type: READ_OCCUPANCY_RATE_DATA_FAILURE,
        error
      });

      throw response;
    }
  };
};

export function readReservationsFilters(): any {
  return async (dispatch: AppDispatch): Promise<ReservationsFilterData> => {
    dispatch({ type: READ_RESERVATIONS_FILTERS_REQUEST });
    try {
      const response = await apiRequest(
        "get",
        `room/reservation-table-filters`
      );
      dispatch({
        type: READ_RESERVATIONS_FILTERS_SUCCESS,
        contents: response?.data || {}
      });
      return response?.data || {};
    } catch (response: any) {
      const error = response && response.error;
      dispatch({
        type: READ_RESERVATIONS_FILTERS_FAILURE,
        error
      });
      throw response;
    }
  };
};

export function readOccupancyRateFilters(): any {
  return async (dispatch: AppDispatch): Promise<OccupancyRateFilterData> => {
    dispatch({ type: READ_OCCUPANCY_RATE_FILTERS_REQUEST });
    try {
      const response = await apiRequest(
        "get",
        `room/occupancy-rate-table-filters`
      );
      dispatch({
        type: READ_OCCUPANCY_RATE_FILTERS_SUCCESS,
        contents: response?.data || {}
      });
      return response?.data || {};
    } catch (response: any) {
      const error = response && response.error;
      dispatch({
        type: READ_OCCUPANCY_RATE_FILTERS_FAILURE,
        error
      });
      throw response;
    }
  };
};

export function roomMassAdd(params: RoomMassAddParams): any {
  return async (dispatch: AppDispatch): Promise<RoomMassAddData> => {
    dispatch({ type: ROOM_MASS_ADD_DATA_REQUEST });

    try {
      const response = await apiRequest(
        'post',
        'room/mass-add',
        {
          data: params.data
        },
        true,
        params.onUploadProgress,
        params.cancelToken
      );

      dispatch({
        type: ROOM_MASS_ADD_DATA_SUCCESS,
        contents: response?.data || {}
      });

      return response?.data || {};
    } catch (response: any) {
      const error = response && response.error;

      dispatch({
        type: ROOM_MASS_ADD_DATA_FAILURE,
        error
      });

      throw response;
    }
  };
};

export function getClientsSelectList(data: GetSelectList): any {
  return async (dispatch: AppDispatch): Promise<any> => {
    try {
      const response = await apiRequest('post', 'room/get-clients-select-list', { data });
      return response?.data || {};
    } catch (response: any) {
      throw response;
    }
  };
}

export function getReservationProvidersSelectList(data: GetSelectList): any {
  return async (dispatch: AppDispatch): Promise<any> => {
    try {
      const response = await apiRequest('post', 'room/get-reservation-providers-select-list', { data });
      return response?.data || {};
    } catch (response: any) {
      throw response;
    }
  };
}

export function exportExcel(params: RoomExportExcelParams): any {
  return async (dispatch: AppDispatch): Promise<void> => {
    dispatch({ type: ROOM_EXPORT_EXCEL_REQUEST });

    try {
      const response: AxiosResponse<any> = await apiRequest(
        "post",
        `room/export-excel`,
        {
          data: params,
          responseType: 'blob',
        }
      ) as AxiosResponse<any>;

      const contentDisposition: string | undefined = response.headers['content-disposition'];

      if (contentDisposition) {
        const matchHeader: RegExpMatchArray | null = contentDisposition.match(/filename=(.*)/);
        const fileName: string = matchHeader && matchHeader[1] ? matchHeader[1] : 'Reservations.xlsx';

        fileDownload(response.data, fileName, response.headers['content-type']);
      }

      dispatch({
        type: ROOM_EXPORT_EXCEL_SUCCESS,
      });
    } catch (response: any) {
      const error = response && response.error;

      dispatch({
        type: ROOM_EXPORT_EXCEL_FAILURE,
        error
      });

      throw response;
    }
  };
};

export function getReportExcel(params: RoomReportExcelParams): any {
  return async (dispatch: AppDispatch): Promise<void> => {
    dispatch({ type: ROOM_REPORT_EXCEL_REQUEST });

    try {
      const response: AxiosResponse<any> = await apiRequest(
        "post",
        `room/get-report-excel`,
        {
          data: params,
          responseType: 'blob',
        }
      ) as AxiosResponse<any>;

      const contentDisposition: string | undefined = response.headers['content-disposition'];

      if (contentDisposition) {
        const matchHeader: RegExpMatchArray | null = contentDisposition.match(/filename=(.*)/);
        const fileName: string = matchHeader && matchHeader[1] ? matchHeader[1] : 'Reservations.xlsx';

        fileDownload(response.data, fileName, response.headers['content-type']);
      }

      dispatch({
        type: ROOM_REPORT_EXCEL_SUCCESS,
      });
    } catch (response: any) {
      const error = response && response.error;

      dispatch({
        type: ROOM_REPORT_EXCEL_FAILURE,
        error
      });

      throw response;
    }
  };
};

export function exportOccupancyRateExcel(params: RoomExportExcelParams): any {
  return async (dispatch: AppDispatch): Promise<void> => {
    dispatch({ type: ROOM_EXPORT_EXCEL_REQUEST });

    try {
      const response: AxiosResponse<any> = await apiRequest(
        "post",
        `room/export-occupancy-rate-excel`,
        {
          data: params,
          responseType: 'blob',
        }
      ) as AxiosResponse<any>;

      const contentDisposition: string | undefined = response.headers['content-disposition'];

      if (contentDisposition) {
        const matchHeader: RegExpMatchArray | null = contentDisposition.match(/filename=(.*)/);
        const fileName: string = matchHeader && matchHeader[1] ? matchHeader[1] : 'Reservations.xlsx';

        fileDownload(response.data, fileName, response.headers['content-type']);
      }

      dispatch({
        type: ROOM_EXPORT_EXCEL_SUCCESS,
      });
    } catch (response: any) {
      const error = response && response.error;

      dispatch({
        type: ROOM_EXPORT_EXCEL_FAILURE,
        error
      });

      throw response;
    }
  };
};

export function getReportOccupancyRateExcel(params: RoomReportExcelParams): any {
  return async (dispatch: AppDispatch): Promise<void> => {
    dispatch({ type: ROOM_REPORT_EXCEL_REQUEST });

    try {
      const response: AxiosResponse<any> = await apiRequest(
        "post",
        `room/get-report-occupancy-rate-excel`,
        {
          data: params,
          responseType: 'blob',
        }
      ) as AxiosResponse<any>;

      const contentDisposition: string | undefined = response.headers['content-disposition'];

      if (contentDisposition) {
        const matchHeader: RegExpMatchArray | null = contentDisposition.match(/filename=(.*)/);
        const fileName: string = matchHeader && matchHeader[1] ? matchHeader[1] : 'Reservations.xlsx';

        fileDownload(response.data, fileName, response.headers['content-type']);
      }

      dispatch({
        type: ROOM_REPORT_EXCEL_SUCCESS,
      });
    } catch (response: any) {
      const error = response && response.error;

      dispatch({
        type: ROOM_REPORT_EXCEL_FAILURE,
        error
      });

      throw response;
    }
  };
};

export function setReservationTableFilters(filters: Filters): any {
  return async (dispatch: AppDispatch) => {
    try {
      dispatch({
        type: SET_RESERVATION_TABLE_FILTERS,
        contents: filters,
        exists: Object.keys(filters).some(key => filters[key]),
      });
    } catch { }
  };
};

export function setOccupancyRateTableFilters(filters: Filters): any {
  return async (dispatch: AppDispatch) => {
    try {
      dispatch({
        type: SET_OCCUPANCY_RATE_TABLE_FILTERS,
        contents: filters,
        exists: Object.keys(filters).some(key => filters[key]),
      });
    } catch { }
  };
};

export function reactivateRoom(id: string): any {
  return async (dispatch: AppDispatch): Promise<ReactivateRoomData> => {
    dispatch({ type: REACTIVATE_ROOM_REQUEST });

    try {
      const response = await apiRequest(
        "put",
        `room/${id}/reactivate`,
      );
      dispatch({
        type: REACTIVATE_ROOM_SUCCESS,
        contents: response?.data || {}
      });

      return response?.data || {};
    } catch (response: any) {
      const error = response && response.error;

      dispatch({
        type: REACTIVATE_ROOM_FAILURE,
        error
      });

      throw response;
    }
  };
};

export function getActivityLogs(roomId: string, data: BaseTableRequest): any {
  return async (dispatch: AppDispatch): Promise<void> => {
    dispatch({ type: GET_ROOM_ACTIVITY_LOGS_REQUEST });

    try {
      const response = await apiRequest('post', `room/${roomId}/get-activity-logs`, { data });
      dispatch({ type: GET_ROOM_ACTIVITY_LOGS_SUCCESS, contents: response?.data || {} });
    } catch (response: any) {
      const error = response && response.error;
      dispatch({ type: GET_ROOM_ACTIVITY_LOGS_FAILURE, error });
      throw response;
    }
  };
};

export async function addNote(roomId: string, data: NoteForm) {
  try {
    await apiRequest('post', `room/${roomId}/notes/add`, { data });
  } catch (response: any) {
    throw response;
  }
}

export async function editNote(roomId: string, noteId: string, data: NoteForm) {
  try {
    await apiRequest('put', `room/${roomId}/notes/${noteId}/edit`, { data });
  } catch (response: any) {
    throw response;
  }
}

export async function deleteNote(roomId: string, noteId: string) {
  try {
    await apiRequest('delete', `room/${roomId}/notes/${noteId}`);
  } catch (response: any) {
    throw response;
  }
}

export function getRoomDetails(roomId: string): any {
  return async (dispatch: AppDispatch): Promise<void> => {
    dispatch({ type: ROOM_DETAILS_REQUEST });

    try {
      const response = await apiRequest("get", `room/${roomId}/details`);
      dispatch({ type: ROOM_DETAILS_SUCCESS, contents: response?.data || {} });
    } catch (response: any) {
      const error = response && response.error;
      dispatch({ type: ROOM_DETAILS_FAILURE, error });
      throw response;
    }
  };
};

export function getLocationMatchesRoomsForMassBooking(data: LocationMatchesRoomsForMassBookingParams): any {
  return async (dispatch: AppDispatch): Promise<void> => {
    dispatch({ type: LOCATION_MATCHES_ROOMS_FOR_MASS_BOOKING_REQUEST });
    try {
      const response = await apiRequest("post", `room/location-matches-rooms-for-mass-booking`, { data });
      dispatch({ type: LOCATION_MATCHES_ROOMS_FOR_MASS_BOOKING_SUCCESS, contents: response?.data || {} });
    } catch (response: any) {
      const error = response && response.error;
      dispatch({ type: LOCATION_MATCHES_ROOMS_FOR_MASS_BOOKING_FAILURE, error });
      throw response;
    }
  };
};

export function getReservationsCount(data: Filters): any {
  return async (dispatch: AppDispatch): Promise<void> => {
    dispatch({ type: GET_RESERVATIONS_COUNT_DATA_REQUEST });
    try {
      const response = await apiRequest('post', `room/get-count`, { data });
      dispatch({ type: GET_RESERVATIONS_COUNT_DATA_SUCCESS, contents: response?.data || {} });
    } catch (response: any) {
      const error = response && response.error;
      dispatch({ type: GET_RESERVATIONS_COUNT_DATA_FAILURE, error });
      throw response;
    }
  };
}

export function getActiveReservationsCount(): any {
  return async (dispatch: AppDispatch): Promise<void> => {
    dispatch({ type: GET_ACTIVE_RESERVATIONS_COUNT_DATA_REQUEST });
    try {
      const response = await apiRequest('get', `room/get-active-reservations-count`);
      dispatch({ type: GET_ACTIVE_RESERVATIONS_COUNT_DATA_SUCCESS, contents: response?.data || {} });
    } catch (response: any) {
      const error = response && response.error;
      dispatch({ type: GET_ACTIVE_RESERVATIONS_COUNT_DATA_FAILURE, error });
      throw response;
    }
  };
}

export function getMassActions(data: GetMassActionsParams): any {
  return async (dispatch: AppDispatch): Promise<void> => {
    dispatch({ type: MASS_ACTIONS_REQUEST });
    try {
      const response = await apiRequest('post', 'room/get-mass-actions', { data });
      dispatch({ type: MASS_ACTIONS_SUCCESS, contents: response?.data || [] });
    } catch (response: any) {
      const error = response && response.error;
      dispatch({ type: MASS_ACTIONS_FAILURE, error });
      throw response;
    }
  };
}

export async function massAddNote(data: MassAddNoteForm) {
  try {
    await apiRequest('post', `room/notes/mass-add`, { data });
  } catch (response: any) {
    throw response;
  }
}

export async function massEditDates(data: massEditDateParams): Promise<void> {
  try {
    await apiRequest('put', `room/mass-edit-dates`, { data });
  } catch (response: any) {
    throw response;
  }
}

export async function massMoveRoom(data: massMoveRoomParams): Promise<void> {
  try {
    await apiRequest('post', `room/mass-move`, { data });
  } catch (response: any) {
    throw response;
  }
}

export async function massCancelRooms(data: massCancelRoomParams): Promise<void> {
  try {
    await apiRequest('put', `room/mass-cancel`, { data });
  } catch (response: any) {
    throw response;
  }
}